import { render, staticRenderFns } from "./SetupTimeTableForClass.vue?vue&type=template&id=7df1dd62&scoped=true"
import script from "./SetupTimeTableForClass.vue?vue&type=script&lang=js"
export * from "./SetupTimeTableForClass.vue?vue&type=script&lang=js"
import style0 from "./SetupTimeTableForClass.vue?vue&type=style&index=0&id=7df1dd62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df1dd62",
  null
  
)

export default component.exports